import { useRef, useEffect, useMemo } from 'react';
import debounce from 'lodash/debounce';

const useDebounce = (callback, ms = 300) => {
  const ref = useRef();

  useEffect(() => {
    ref.current = callback;
  }, [callback]);

  const debouncedCallback = useMemo(() => {
    const func = (...args) => {
      ref.current?.(...args);
    };

    return debounce(func, ms);
  }, [ms]);

  useEffect(() => () => debouncedCallback.cancel(), [debouncedCallback]);

  return debouncedCallback;
};

export default useDebounce;